import { render, staticRenderFns } from "./AddRechargeWithdrawDialog.vue?vue&type=template&id=c87b4f92&scoped=true&"
import script from "./AddRechargeWithdrawDialog.vue?vue&type=script&lang=js&"
export * from "./AddRechargeWithdrawDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddRechargeWithdrawDialog.vue?vue&type=style&index=0&id=c87b4f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b4f92",
  null
  
)

export default component.exports